module.exports = __webpack_public_path__ + "img/city14.679d04ff.jpg";